<template>
  <div class="button">
      <input type="submit" name="submit" v-bind:value="value" />
  </div>
</template>

<script>
export default {
  name: 'formbutton',
  props: {
      value: String
  },
  mounted() {

  }
}
</script>

<style scoped lang="scss">
  .button {
    cursor: pointer;
  }
  input {
    cursor: pointer;
    border: 1px solid $red;
    background: transparent;
    text-align: center;
    box-shadow: none;
    font-family: $headings-font-family;
    letter-spacing: 3px;
    text-transform: uppercase;
    color: $red;
    padding: 7px 10px;
    width: 300px;
    max-width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
    border-radius: none;
  }
</style>
